var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3213 2.01196L22.3213 5.01196L20.0343 7.29996L17.0343 4.29996L19.3213 2.01196ZM8.33325 16H11.3333L18.6203 8.71296L15.6203 5.71296L8.33325 13V16Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 19H8.49125C8.46525 19 8.43825 19.01 8.41225 19.01C8.37925 19.01 8.34625 19.001 8.31225 19H5.33325V5H12.1803L14.1803 3H5.33325C4.23025 3 3.33325 3.896 3.33325 5V19C3.33325 20.104 4.23025 21 5.33325 21H19.3333C19.8637 21 20.3724 20.7893 20.7475 20.4142C21.1225 20.0391 21.3333 19.5304 21.3333 19V10.332L19.3333 12.332V19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.fd2d7462a5d69d248665957424071cab.svg";
export { ForwardRef as ReactComponent };